import { render, staticRenderFns } from "./SectorForm.vue?vue&type=template&id=0b74a9ba&"
import script from "./SectorForm.vue?vue&type=script&lang=js&"
export * from "./SectorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports